import React, { Component } from "react";
import veiuligheidshuis from "../../assets/Curacao Ministerie.PNG";
import PhoneInput from "react-phone-number-input";
import Api from "../../Api";

class InformatieForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      loading: false,
    };

    this.DateField = this.DateField.bind(this);
    this.TextAreaField = this.TextAreaField.bind(this);
    this.SelectField = this.SelectField.bind(this);
    this.EmailField = this.EmailField.bind(this);
    this.TextField = this.TextField.bind(this);
    this.PhoneField = this.PhoneField.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  async onSubmit(data) {
    this.setState({ loading: true });

    const newAdressData = {
      defDossier: 1941,
      33691: data.straatnaam_persoon,
      33694: data.politiedistrict,
      33696: data.wijk_persoon,
      33697: data.geozone_persoon,
    };

    const idnewAdressData = await Api.dossiers.Create(newAdressData);

    const adressData = {
      defDossier: 1826,
      31298: data.huisnummer_persoon,
      31319: data.toevoeging_persoon,
      31331: data.woonplaats_persoon,
      33698: [idnewAdressData.id],
    };

    const idadressData = await Api.dossiers.Create(adressData);
 
    this.setState({ loading: false });
    this.setState({ showModal: true });
  }

  DateField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>

          <input
            {...register(name, rules)}
            type="date"
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  SelectField(label, name, options, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>

          <select
            {...register(name, rules)}
            name={name}
            onChange={(e) => {
              this.setState({ [name]: [e.target.value] });
            }}
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
          >
            <option value="">Selecteer een optie</option>
            {options.map((opt) => (
              <option value={opt.value}>{opt.label}</option>
            ))}
          </select>
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  TextAreaField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start w-full">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <textarea
            rows={3}
            {...register(name, rules)}
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
            className="block p-2 w-full text-sm text-gray-900  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
          ></textarea>

          {errors[name] && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  TextField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <input
            {...register(name, rules)}
            type="text"
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name] && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  EmailField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required.value && <span className="text-red-500">*</span>}{" "}
            {label}
          </label>
          <input
            {...register(name, rules)}
            type="email"
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  PhoneField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <PhoneInput
            placeholder="Enter phone number"
            {...register(name, rules)}
            value={this.state[name]}
            onChange={(value) => this.setState({ [name]: value })}
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
          />

          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <>
        {this.state.loading && (
          <div className="flex items-center justify-center h-screen fixed w-full z-50">
            <div className="bg-slate-500 absolute w-full h-full  opacity-50"></div>
            <div class="relative">
              <div className="h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-200"></div>
              <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-300 animate-spin"></div>
            </div>
          </div>
        )}
        {this.state.showModal && (
          <div
            id="successModal"
            tabindex="-1"
            aria-hidden="true"
            class="flex  overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full"
          >
            <div className="bg-slate-500 absolute w-full h-full opacity-50"></div>
            <div class="relative p-4 w-full max-w-md h-full md:h-auto">
              <div class="relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
                <button
                  onClick={() => {
                    this.setState({ showModal: false });
                    this.props.reset();
                  }}
                  type="button"
                  class="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-toggle="successModal"
                >
                  <svg
                    aria-hidden="true"
                    class="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
                <div class="w-12 h-12 rounded-full bg-green-100 dark:bg-green-900 p-2 flex items-center justify-center mx-auto mb-3.5">
                  <svg
                    aria-hidden="true"
                    class="w-8 h-8 text-green-500 dark:text-green-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Success</span>
                </div>
                <p class="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
                  Successfully!
                </p>
                <button
                  onClick={() => {
                    this.setState({ showModal: false });
                    this.props.reset();
                  }}
                  type="button"
                  class="py-2 px-3 text-sm font-medium text-center text-white rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 "
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="p-5 d-flex flex-column gap-4">
          <div className="d-flex justify-content-center w-full">
            <img src={veiuligheidshuis} alt="logo Zorg-curacao" />
          </div>
          <h1 className="text-3xl font-bold spt-2">
            Gegevens van betrokken (minderjarige of slachtoffer).
          </h1>
        </div>
        <section
          className="px-5 d-flex flex-column gap-4 mb-4"
          onSubmit={this.submitForm}
        >
          <div
            className=" bg-white rounded-lg shadow-md border border-gray-200 p-6"
            onSubmit={this.submitForm}
          >
            <form className="grid grid-cols-3  gap-3 mt-3">
              {this.TextField("Voornamen", "voornamen_persoon", {
                required: true,
              })}
              {this.TextField("Achternaam", "gevens_persoon", {
                required: true,
              })}
              {this.EmailField("E-mailadres", "email_persoon", {
                required: { value: false, message: "Email is required" },
              })}
              {this.PhoneField("Telefoon ", "phone_persoon", {
                required: "This Field Is Required",
              })}
              {this.DateField("Geboortedatum", "geboortedatum_melding", {
                required: "This Field required",
              })}
              {this.SelectField(
                "Geslacht:",
                "geslacht",
                [
                  {
                    value: 15943,
                    label: "Onbekend",
                  },
                  {
                    value: 15941,
                    label: "Vrouw",
                  },
                  {
                    value: 15938,
                    label: "Man",
                  },
                ],
                {
                  required: true,
                }
              )}
              {this.TextField(
                "Identiteitsnummer",
                "identiteitsnummer_persoon",
                {
                  required: true,
                }
              )}
              {this.TextField("Geboorteplaats", "geboorteplaats_persoon", {
                required: true,
              })}
              {this.SelectField(
                "Gezag berust bij ",
                "gezag",
                [
                  {
                    value: 38863,
                    label: "Voogd",
                  },
                  {
                    value: 35637,
                    label: "Familielid",
                  },
                  {
                    value: 35636,
                    label: "Pleegouders",
                  },
                  {
                    value: 35635,
                    label: "Moeder",
                  },
                  {
                    value: 35634,
                    label: "Vader",
                  },
                  {
                    value: 35633,
                    label: "Ouders",
                  },
                ],
                {
                  required: false,
                }
              )}
            </form>

            <div className="flex items-start my-4">
              <label
                for="tussenvoegsels"
                className="form-label fw-bold float-start"
              >
                Adres:
              </label>
            </div>

            <form className="grid grid-cols-3  gap-3 mt-3">
              {this.TextField("Straatnaam", "straatnaam_persoon", {
                required: true,
              })}
              {this.SelectField(
                "In politiedistrict:",
                "politiedistrict",

                [
                  {
                    value: 631735,
                    label: "Otrobanda",
                  },
                  {
                    value: 631734,
                    label: "Barber",
                  },
                  {
                    value: 631733,
                    label: "Rio Canario",
                  },
                  {
                    value: 631732,
                    label: "Montagne",
                  },
                  {
                    value: 631731,
                    label: "Punda",
                  },
                ],
                {
                  required: true,
                }
              )}
              {this.TextField("Wijk", "wijk_persoon", {
                required: false,
              })}
              {this.TextField("Geozone", "geozone_persoon", {
                required: false,
              })}
            </form>

            <form className="grid grid-cols-3  gap-3 mt-3">
              {this.TextField("Huisnummer", "huisnummer_persoon", {
                required: true,
              })}
              {this.TextField("Toevoeging ", "toevoeging_persoon", {
                required: false,
              })}
              {this.TextField("Woonplaats ", "woonplaats_persoon", {
                required: true,
              })}
            </form>

            <form onSubmit={handleSubmit(this.onSubmit)}>
              <div className="flex justify-end items-end gap-3 mt-4">
                <button
                  type="submit"
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
                >
                  Verstuur
                </button>
              </div>
            </form>
          </div>
        </section>
      </>
    );
  }
}

export default InformatieForm;
